var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Catalogs", {
    attrs: {
      title: "Гражданства",
      "create-text": "Новое",
      "fetch-data": _vm.fetchData,
      fields: _vm.fields,
      "route-create": "CitizenshipAdd",
      "route-edit": "CitizenshipEdit",
      "route-view": "CitizenshipView",
      "route-path": "/citizenships",
      "can-edit": _vm.canEditCitizenshipCatalogs()
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a3084ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a3084ea","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogs/Citizenships/Citizenships.vue
// module id = null
// module chunks = 